import {
  NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';

function padNumber(value: number | null) {
  if (!isNaN(value) && value !== null) {
    return `0${value}`.slice(-2);
  } else {
    return '';
  }
}

@Injectable()
@Injectable()
export class CustomDateAdapter {
  fromModel(value: Date): NgbDateStruct {
    return value
      ? ({
          year: value.getFullYear(),
          month: value.getMonth() + 1,
          day: value.getDate(),
        } as NgbDateStruct)
      : null;
  }

  toModel(date: NgbDateStruct): Date {
    return date ? new Date(date.year, date.month - 1, date.day) : null;
  }
}

@Injectable()
export class CustomDateParserFormatter {
  parse(value: Date): NgbDateStruct {
    return value
      ? ({
          year: value.getFullYear(),
          month: value.getMonth() + 1,
          day: value.getDate(),
        } as NgbDateStruct)
      : null;
  }
  format(date: NgbDateStruct): string {
    return date
      ? ('0' + date.month).slice(-2) +
          '-' +
          ('0' + date.day).slice(-2) +
          '-' +
          date.year
      : null;
  }
}
